export { default as ICON } from './icons'
export { default as IMAGE } from './images'
